import {AfterViewChecked, Component, ElementRef, Inject, Renderer2, ViewChild} from '@angular/core';
import {Config} from '../../../models/config';
import {FormGroup} from '@angular/forms';
import {L10N_LOCALE, L10nLocale} from 'angular-l10n';

@Component({
  selector: 'storever-form-text-area',
  templateUrl: './form-text-area.component.html',
  styleUrls: ['./form-text-area.component.scss']
})
export class FormTextAreaComponent implements AfterViewChecked {
  config: Config;
  group: FormGroup;
  scrollTop = true
 // @ViewChild('textArea', { read: ElementRef }) el: ElementRef;
  @ViewChild('textArea', {static: false , read: ElementRef }) el: ElementRef;
  @ViewChild('comment', {static: false , read: ElementRef }) scrollContainer!: ElementRef;
  get isEnabled(): boolean {
    return this.group.disabled;
  }

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale, private renderer: Renderer2) {
  }

  ngAfterViewChecked(): void {
    this.autoGrow();
    this.scrollDown();
  }

  autoGrow(): void {
    if (this.el) {
      const textArea = this.el.nativeElement;
      this.renderer.setStyle(textArea, 'overflow', 'hidden');
      this.renderer.setStyle(textArea, 'height', '0px');
      this.renderer.setStyle(textArea, 'height', textArea.scrollHeight + 'px');
    }
  }

  get getValue(): string | number {
    if (this.group.get(this.config.controlName[0]).value) {
     return this.group.get(this.config.controlName[0]).value.replace(/\r\n/g, '<br>');
    }
    return null;
  }

  scrollDown(): void {
    if ( this.scrollContainer && this.scrollTop) {
      const element = this.scrollContainer.nativeElement;
      element.scrollTop = element.scrollHeight;
      this.scrollTop = false;

    }

  }

}
